export default "__VITE_ASSET__DjKbUa1N__"